import { connectCallBtwDP } from "../../pages/actions/actions";
import { ShowAlert } from "../../utils/showAlert";
import { UseGetStoreData } from "../getStoreData/UseGetStoreData"

export const useDoctorPatientCall = () => {
    const { getTicketData } = UseGetStoreData();
    const handleConnectCallBtwDP = async (customerNumber: string, agentId: string) => {
        const payload = {
            agentId,
            customerNumber,
        };
        const res = await connectCallBtwDP(payload, getTicketData._id);
        return ShowAlert("success", res?.message);
    };
    return {
        handleConnectCallBtwDP
    }
}